module.exports = __webpack_public_path__ + "img/about-hero-desktop-01.865dc8c8.svg";